import React from 'react';
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridColDef } from '@mui/x-data-grid';
import { Box, IconButton, Typography } from '@mui/material';
import { colors } from 'common/constants';
import { IUniqLink } from 'types/uniq-link';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';

const UniqLinkGridColumn = (
    onClickDeleteRow: (row: IUniqLink) => void,
    onClickEditRow: (row: IUniqLink) => void
) => {
    const columnsDefinitions: GridColDef[] = [
        {
            ...GRID_CHECKBOX_SELECTION_COL_DEF,
            width: 45,
        },
        {
            field: 'code',
            headerName: 'Mã Code',
            flex: 1.5,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    height={'100%'}
                    width={'100%'}
                    pr={1}
                >
                    <Typography
                        component="span"
                        fontSize={'12px'}
                        lineHeight={'14px'}
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            flex: 1,
                        }}
                        title={params.row.code}
                    >
                        {params.row.code}
                    </Typography>
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(params.row.code);
                            toast.success('Đã sao chép Mã Code');
                        }}
                        sx={{ ml: 1 }}
                    >
                        <ContentCopyIcon
                            sx={{ fontSize: '16px', color: colors.main }}
                        />
                    </IconButton>
                </Box>
            ),
        },
        {
            field: 'email',
            headerName: 'Email',
            flex: 1.2,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    height={'100%'}
                >
                    <Typography
                        component="span"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                    >
                        {params.row.email}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'url_survey',
            headerName: 'Link Survey',
            flex: 1.5,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    height={'100%'}
                    width={'100%'}
                    pr={1}
                >
                    <Typography
                        component="span"
                        fontSize={'12px'}
                        lineHeight={'14px'}
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            flex: 1,
                        }}
                        title={params.row.url_survey}
                    >
                        {params.row.url_survey}
                    </Typography>
                    <IconButton
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(
                                params.row.url_survey
                            );
                            toast.success('Đã sao chép Link Survey');
                        }}
                        sx={{ ml: 1 }}
                    >
                        <ContentCopyIcon
                            sx={{ fontSize: '16px', color: colors.main }}
                        />
                    </IconButton>
                </Box>
            ),
        },
        {
            field: 'created_at',
            headerName: 'Ngày tạo',
            flex: 1,
            renderCell: (params) => (
                <Box component="div">
                    <Typography
                        component="span"
                        fontSize={'14px'}
                        lineHeight={'17px'}
                    >
                        {params.row.created_at}
                    </Typography>
                </Box>
            ),
        },
        {
            field: 'actions',
            headerName: 'Thao tác',
            sortable: false,
            flex: 0.8,
            renderCell: (params) => (
                <Box
                    component="div"
                    display="flex"
                    alignItems="center"
                    gap={0.5}
                    height={'100%'}
                >
                    <IconButton
                        size="small"
                        onClick={() => onClickEditRow(params.row)}
                    >
                        <EditOutlinedIcon
                            sx={{ fontSize: '18px', color: colors.main }}
                        />
                    </IconButton>
                    <IconButton
                        size="small"
                        onClick={() => onClickDeleteRow(params.row)}
                    >
                        <DeleteOutlineOutlinedIcon
                            sx={{ fontSize: '18px', color: colors.main }}
                        />
                    </IconButton>
                </Box>
            ),
        },
    ];
    return columnsDefinitions;
};

export default UniqLinkGridColumn;
